// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1oh7v","header":"PatientQuestionnaire_header__3HR59","info":"PatientQuestionnaire_info__1lETj"};